import React from 'react';
import { sprintf } from 'sprintf';

import { formatCurrentUserPrice } from 'services/stringFormating';

import * as Types from 'types';

type Props = {
  bundle: Types.Bundle;
};

export const PurchasableBundleBanner: React.FC<Props> = ({ bundle }) => (
  <div className='mb-1'>
    <div className='fw-500 mb-mini'>{bundle.title}</div>
    <p className='mb-1'>{bundle.description}</p>
    <p className='standfirst standfirst--subtle mb-mini'>
      {bundle.deliveryPrice === 0 && 'Free worldwide shipping'}
      {bundle.deliveryPrice > 0 &&
        sprintf('Worldwide shipping %s.', formatCurrentUserPrice(bundle.deliveryPrice))}
    </p>
    <a className='link-border' href={Routes.terms_shipping_and_returns_pages_path()}>
      Shipping & Returns
    </a>
  </div>
);
